<template>
  <NavQuestion
      :heading="heading"
      :number="number"
      :subHeading="subHeading"
      :questionOptions="true"
  >
    <template v-slot:contents>
      <InputOptionLarge
          :image="'https://mylastwill.s3.amazonaws.com/static/img/button-executor-professional.png'"
          :letter="'a'"
          :selected="executorProfessional"
          :option="'Professional Executors'"
          @selected="saveProfessional"
      >
        <template v-slot:text>
          <template v-if="isScotlandOrNI">
            Please provide the company details of the Professional Executors that you wish to provide Probate on your
            estate.
          </template>
          <template v-else>
            Our professional executors have all of the resources and experience
            necessary to deal with the administration of your estate; providing
            you with total peace of mind.
          </template>
        </template>

        <template v-slot:input>
          <template v-if="isScotlandOrNI">
            <div class="partner-invite" style="min-height: 350px">
              <div v-if="show.manual || (!executorProfessionalCustom)" class="row pb30">
                <div class="col-lg-8 col-md-10 col-sm-12 col-xs-12">
                  <AddressSearch :business-only="true" placeholder="Business Search..." colour="grey"
                                 @addressSelected="setAddress"/>
                </div>
              </div>
              <div v-if="
              !show.manual && executorProfessionalCustom &&
              executorProfessionalCustom.company_name &&
              executorProfessionalCustom.address_line_1 &&
              executorProfessionalCustom.post_code &&
              executorProfessionalCustom.country
            " class="row pb30">
                <div class="col-12">
                  <div

                      class="address"
                  >
                    <p>{{ executorProfessionalCustom.company_name }}</p>
                    <p>{{ executorProfessionalCustom.address_line_1 }}</p>
                    <p v-show="executorProfessionalCustom.address_line_2">
                      {{ executorProfessionalCustom.address_line_2 }}
                    </p>
                    <p v-show="executorProfessionalCustom.address_line_3">{{
                        executorProfessionalCustom.address_line_3
                      }}</p>
                    <p>{{ executorProfessionalCustom.post_code }}</p>
                    <p>{{ executorProfessionalCustom.country }}</p>
                  </div>
                </div>
              </div>


              <!-- manual professional address edit -->
              <div v-else-if="show.manual">
                <div class="row">
                  <div class="col-lg-8 col-md-10 col-sm-12 col-xs-12">
                    <div class="input-container">
                      <input
                          ref="companyName"
                          @keyup.enter="$refs.address1.focus()"
                          v-model="professionalExecutorForm.company_name"
                          required
                          id="company_name"
                          type="text"
                          placeholder="Company Name"
                          class="input-standard-grey validation"
                      />
                      <label for="company_name">Company Name</label>
                    </div>
                    <div class="input-container">
                      <input
                          ref="address1"
                          @keyup.enter="$refs.address2.focus()"
                          v-model="professionalExecutorForm.address_line_1"
                          required
                          id="address_line_1"
                          type="text"
                          placeholder="Building Name or Number"
                          class="input-standard-grey validation"
                      />
                      <label for="address_line_1">Address Line 1</label>
                    </div>
                    <div class="input-container">
                      <input
                          @keyup.enter="$refs.address3.focus()"
                          ref="address2"
                          v-model="professionalExecutorForm.address_line_2"
                          id="address_line_2"
                          required
                          type="text"
                          placeholder="Street Name"
                          class="input-standard-grey validation"
                      />
                      <label for="address_line_2">Address Line 2</label>
                    </div>

                    <div class="input-container">
                      <input
                          ref="address3"
                          @keyup.enter="$refs.postcode.focus()"
                          v-model="professionalExecutorForm.address_line_3"
                          required
                          id="address_line_3"
                          type="text"
                          placeholder="Town"
                          class="input-standard-grey validation"
                      />
                      <label for="post_townaddress_line_3">Post Town</label>
                    </div>

                  </div>
                </div>
                <!-- post code and country -->
                <div class="row">
                  <div class="col-lg-4 col-md-5 col-sm-12 col-xs-12">
                    <div class="input-container fadeIn-5">
                      <input
                          ref="postcode"
                          @keyup.enter.stop="show.focusCountry = true"
                          v-model="professionalExecutorForm.post_code"
                          required
                          id="post_code"
                          type="text"
                          placeholder="Postcode"
                          class="input-standard-grey validation"
                      />
                      <label for="post_code">Postcode</label>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-5 col-sm-12 col-xs-12">
                    <CountrySelect
                        v-bind:selectedCountry="professionalExecutorForm.country"
                        :focus="show.focusCountry"
                        :required="true"
                        input-colour="input-standard-grey grey"
                        @enter="forward"
                        @selectedCountry="setCountry"
                    ></CountrySelect>
                  </div>
                </div>
              </div>

              <!-- edit address button -->
              <div class="row pb30">
                <div class="col-lg-8 col-md-10 col-sm-12 col-xs-12">
                  <p
                      @click="editSave"
                      class="align-right link text-small"
                  >
                    {{
                      show.manual ? 'Save' : !!professionalExecutorForm.id ? 'Edit Business Address' : 'Add Business Address Manually'
                    }}
                  </p>
                </div>
              </div>


            </div>
          </template>

        </template>


      </InputOptionLarge>

      <!--      <InputOptionLarge-->
      <!--        :image="'https://mylastwill.s3.amazonaws.com/static/img/button-pro-fam.png'"-->
      <!--        :letter="'b'"-->
      <!--        :selected="executorProfessionalAndFamily"-->
      <!--        :option="'Friends or Family with Professional Executors'"-->
      <!--        @selected="saveProfessionalAndFamily"-->
      <!--      >-->
      <!--        <template v-slot:text>-->
      <!--          A combination of lay executors (family members or friends) and-->
      <!--          professionals could be ideal. The professionals can deal with taxes,-->
      <!--          accounts and other more complex aspects of the administration, whilst-->
      <!--          family can deal with your funeral and everything else.-->
      <!--        </template>-->
      <!--      </InputOptionLarge>-->

      <InputOptionLarge
          :image="'https://mylastwill.s3.amazonaws.com/static/img/button-executor-non-professional.png'"
          :letter="'b'"
          :selected="
          executorProfessional === false &&
          executorProfessionalAndFamily === false
        "
          :option="'Friends and Family Only'"
          @selected="saveFamily"
      >
        <template v-slot:text>
          If you are appointing non-professionals, you may wish to consider
          close family members or friends. They can obtain professional advice
          if they find the process too difficult or time-consuming, but
          ultimately they are in charge.
        </template>
      </InputOptionLarge>
      <AlternativeProfessionalExecutorsModal
          v-show="show.alternativeExecutorsModal"
          @close="show.alternativeExecutorsModal = false"
          @confirm="$router.push(forwardTo).catch((e) => console.log(e))"
      />

      <IntroModal
          v-show="show.intro"
          :show="show.intro"
          @close="show.intro = false"
      ></IntroModal>
    </template>
    <template v-slot:navButtons>
      <NavQuestionButtons
          v-bind:validated="isValidated"
          v-bind:forwardText="'Next'"
          @forwardClick="forward"
          v-bind:backLink="'/home'"
          v-bind:center="false"
          v-bind:loading="loading"
      ></NavQuestionButtons>
    </template>
  </NavQuestion>
</template>

<script>
import NavQuestion from '@/common/ui/NavQuestion'
import NavQuestionButtons from '@/common/ui/NavQuestionButtons'
import InputOptionLarge from '@/common/ui/InputOptionLarge'
import IntroModal from '../IntroModal'
import AlternativeProfessionalExecutorsModal
  from '@/views/pages/ExecutorsPage/Questions/Helpers/AlternaiveProfessionalExecutorsModal'
import CountrySelect from '@/common/components/CountrySelect.vue'
import AddressSearch from '@/common/components/AddressSearch.vue'

import { http } from '@/services'
import { isEqual } from 'lodash'

export default {
  name: 'ExecutorsTypeOf',
  components: {
    AddressSearch,
    CountrySelect,
    AlternativeProfessionalExecutorsModal,
    NavQuestion,
    NavQuestionButtons,
    InputOptionLarge,
    IntroModal
  },
  watch: {
    executorProfessionalCustom: {
      immediate: true,
      handler (value) {
        if (value) {
          this.setExecutorProfessionalForm()
        } else {
          this.clearExecutorProfessionalForm()
        }
      }
    }
  },
  computed: {
    partner () {
      return this.$store.getters.partner
    },
    people () {
      return this.$store.getters.people
    },
    details () {
      return this.$store.getters.details
    },
    executorProfessional () {
      return this.$store.getters.details.executor_professional
    },
    executorProfessionalCustom () {
      return this.details.executor_professional_custom
    },
    executorProfessionalAndFamily () {
      return this.$store.getters.details.executor_professional_and_family
    },
    personalDetails () {
      return this.$store.getters.personalDetails
    },
    isScotlandOrNI () {
      // needs a professional executor selecting if not in following countries and is not a broker coupon with an
      // alternative professional executor selected by the broker
      return ['Northern Ireland', 'Scotland'].includes(this.$store.getters.personalDetails.country) && !this.alternativeProfessionalExecutors
    },
    isValidated () {
      if (this.executorProfessional && this.isScotlandOrNI) {
        // if scotland or NI then must have a professional executor custom object created
        return Number.isInteger(this.executorProfessionalCustom?.id)
      }
      if (this.executorProfessional !== null) return true
      return false
    },
    forwardTo () {
      if (this.executorProfessional) {
        return '/executors/check_and_confirm'
      } else if (this.executorProfessionalAndFamily) {
        return '/executors/primary'
      } else if (this.executorProfessional === false && this.partner) {
        return '/executors/partner'
      } else if (this.executorProfessional === false && !this.partner) {
        return '/executors/primary'
      }
      return '/executors/primary'
    },
    alternativeProfessionalExecutors () {
      if (
          this.$store.getters.checkoutBasket &&
          this.$store.getters.checkoutBasket.coupon &&
          this.$store.getters.checkoutBasket.coupon.broker &&
          this.$store.getters.checkoutBasket.coupon.broker
              .alternative_professional_executors
      ) {
        return this.$store.getters.checkoutBasket.coupon.broker
            .alternative_professional_executors
      } else {
        return false
      }
    }
  },
  data () {
    return {
      show: {
        intro: true,
        alternativeExecutorsModal: false,
        manual: false,
        focusCountry: false

      },
      loading: false,
      number: '1',
      heading: 'What type of executors would you like to appoint?',
      subHeading:
          'Choosing Executors can be difficult as the role carries with it a considerable amount of legal, tax and administrative responsibility. ' +
          'If the estate is uncomplicated, relatives or family friends could be suitable. Appointing professionals will remove the stress and strain that a ' +
          'family member or friend could be subjected to; particularly for more complex estates.',
      professionalExecutorForm: this.blankExecutorProfessionalForm()
    }
  },
  methods: {
    async editSave () {
      if (this.show.manual) {
        // save
        await this.saveProfessionalExecutorCustom()
        this.show.manual = false
      } else {
        // edit address
        this.show.manual = true
      }

    },
    setExecutorProfessionalForm () {
      if (this.executorProfessionalCustom) {
        let data = Object.assign({}, this.executorProfessionalCustom)
        this.professionalExecutorForm.id = data.id
        this.professionalExecutorForm.company_name = data.company_name
        this.professionalExecutorForm.address_line_1 = data.address_line_1
        this.professionalExecutorForm.address_line_2 = data.address_line_2
        this.professionalExecutorForm.address_line_3 = data.address_line_3
        this.professionalExecutorForm.post_code = data.post_code
        this.professionalExecutorForm.country = data.country
      }
    },
    clearExecutorProfessionalForm () {
      this.professionalExecutorForm = this.blankExecutorProfessionalForm()
    },
    blankExecutorProfessionalForm () {
      return {
        id: null,
        company_name: null,
        address_line_1: null,
        address_line_2: null,
        address_line_3: null,
        post_code: null,
        country: null,
      }
    },
    saveFamily () {
      this.$store.commit('details', {
        executor_professional: false,
        executor_professional_and_family: false
      })
      this.resetExecutors()
    },
    saveProfessional () {
      this.$store.commit('details', {
        executor_professional: true,
        executor_professional_and_family: false
      })
      this.resetExecutors()
    },
    async saveProfessionalExecutorCustom () {
      console.log('saveProfessionalExecutorCustom', this.executorProfessionalCustom)
      if (this.executorProfessionalCustom?.id) {
        console.log(this.professionalExecutorForm, this.executorProfessionalCustom)
        if (!isEqual(this.professionalExecutorForm, this.executorProfessionalCustom)) {
          // update only if form and original store data is different
          await this.patchProfessionalExecutorCustom()
        }
      } else {
        // create new
        await this.postProfessionalExecutorCustom()
      }
      return true
    },
    async patchProfessionalExecutorCustom () {
      console.log('patchProfessionalExecutorCustom')
      let data = Object.assign({}, this.professionalExecutorForm)
      return await http.patch('/wills/api/professional_executor_custom', data).then(response => {
        this.$store.commit('details', {
          executor_professional_custom: response.data,
        })
        return true
      }).catch(error => {
        console.log(error)

        this.$notification.error('Error saving professional executor')
        return false
      })
    },
    async postProfessionalExecutorCustom () {
      console.log('postProfessionalExecutorCustom')
      let data = Object.assign({}, this.professionalExecutorForm)
      return await http.post('/wills/api/professional_executor_custom', data).then(response => {
        this.$store.commit('details', {
          executor_professional_custom: response.data,
        })
        return true
      }).catch(error => {
        console.log(error)
        this.$notification.error('Error saving professional executor')
        return false
      })
    },
    async setAddress (value) {
      if (value) {
        console.log('address value', value)
        this.professionalExecutorForm.company_name = value.line_1
        this.professionalExecutorForm.address_line_1 = value.line_2
        this.professionalExecutorForm.address_line_2 = value.line_3
        this.professionalExecutorForm.address_line_3 = value.post_town
        this.professionalExecutorForm.post_code = value.postcode
        this.professionalExecutorForm.country = value.country
        await this.saveProfessionalExecutorCustom()
      }
      return true
    },
    setCountry (value) {
      this.professionalExecutorForm.country = value
    },
    resetExecutors () {
      this.people.forEach((person) => {
        let personCopy = Object.assign({}, person)
        personCopy.executor_sole_primary = false
        personCopy.executor_primary = false
        personCopy.executor_secondary = false
        personCopy.executor_backup = false
        this.$store.commit('personAdd', personCopy)
      })
      this.$store.commit('details', {
        executors_backup_required: false
      })
    },
    async forward () {
      if (this.isScotlandOrNI && this.executorProfessional) {
        console.log('forward professional NI or Scotland')
        // save any changes
        await this.saveProfessionalExecutorCustom()
      }
      if (
          this.alternativeProfessionalExecutors &&
          (this.executorProfessional || this.executorProfessionalAndFamily)
      ) {
        this.show.alternativeExecutorsModal = true
      } else {
        this.$router.push(this.forwardTo).catch((e) => console.log(e))
      }
    }
  }
}
</script>

<style scoped lang="scss">
.address {
  background-color: rgba(#345a7a, 0.7);
  padding: 30px;
  border-radius: 10px;
  color: #ffffff;
}
</style>
